import React, { Component } from 'react'
import {Card, Button} from '@lmig/lmds-react'

export class RequestTypeCard extends Component {
    constructor(props) {
        super(props);
        this.title = props.title
        this.formNumber = props.formNumber
    }
    render() {
        const formNumber = this.formNumber
        return(
        <Card style={{backgroundColor: '#1A1446', color: 'white', padding:'32px',
            marginTop:'16px', marginBottom:'16px',
            marginLeft:'8px', marginRight:'8px'}}>
            <p> {this.title} </p>
            <hr style={{marginTop:'32px', marginBottom:'32px'}}/>
            <Button
                variant='primary'
                onClick={function () {
                    window.open(`/form/${formNumber}`)}}
                size='medium'>
                Select
            </Button>
        </Card>)
    }
}